import {useParams} from "react-router-dom";
 
 export default function GetProjectType() {
    const { id } = useParams();
    return (
     <div className="mt-4">
      <h2>You are viewing our {id} projects...</h2>
     </div>
    );
   }